var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"blm-richText",domProps:{"innerHTML":_vm._s(_vm.richtextValue.content)},on:{"click":_vm.clickSup}}),_c('BlmSourceDetail',{attrs:{"visible":_vm.sourceDetailVisible,"sourceData":_vm.sourceData},on:{"update:visible":function($event){_vm.sourceDetailVisible = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }